import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import Helmet from 'react-helmet';
import isElectron from 'is-electron';
import { components, contentfulModels } from '@glowforge/ui-common';

import { articlePropTypes } from 'app/selectors/support';
import Article from 'app/components/support/article';
import BottomButton from './bottom-button';
import ArticleCard from './article-card';

import 'app/common/components/scroll-page.less';
import './unboxing.less';

const { pageStringsPropType } = contentfulModels;
const { Button } = components;

const Unboxing = ({
  pageStrings,
  nextUrl,
  title,
  subTitle,
  unboxingArticle,
  features,
  goTo,
  params,
  articleList,
}) => {
  const { UNBOXING_UPDATE_ENABLED } = features;
  const header = title && !UNBOXING_UPDATE_ENABLED ? <h1 className='h1'>{title}</h1> : null;
  const subHeader = subTitle ? <div className='subTitle'>{subTitle}</div> : null;
  const goToNext = () => { window.location = nextUrl; };

  useEffect(() => {
    document.querySelectorAll('a').forEach((el) => {
      if (el.getAttribute('id') === 'setup-url') {
        el.setAttribute('href', nextUrl);
      } else if (isElectron()) {
        el.setAttribute('target', '_blank');
        el.setAttribute('rel', 'noopenner noreferrer');
      }
    });
  }, []);

  if (unboxingArticle.fields) {
    _.pull(unboxingArticle.fields.entries,
      _.find(unboxingArticle.fields.entries, { fields: { id: 'wifi-setup' } }),
    );
  }

  const onClick = (articleId) => {
    if (articleId === 'connect-to-wi-fi') {
      goToNext();
      return;
    }
    goTo(articleId);
  };

  const { slug } = params;
  const nextArticle = slug ? pageStrings[`${slug}-next`] : pageStrings['unboxing-next'];
  const { fields: { id } } = unboxingArticle;
  const canGoBack = id !== 'lets-get-started';
  const prevArticle = canGoBack && pageStrings[`${slug}-prev`];

  return (
    <div className='Unboxing scrollPage contentPage'>
      <Helmet title={`Glowforge Setup - ${title}`} />
      {header}
      {subHeader}
      <div className='content grow'>
        <div className={UNBOXING_UPDATE_ENABLED && 'articleContainer'}>
          <Article {...unboxingArticle} unboxingUpdateEnabled={UNBOXING_UPDATE_ENABLED} />
          {UNBOXING_UPDATE_ENABLED
            ? (
              <React.Fragment>
                <div className='setupGuideContainer'>
                  {!slug && (
                    <React.Fragment>
                      <h3 className='setupGuideHeader'>{pageStrings['setup-guide-header']}</h3>
                      {articleList.map(article => (
                        <ArticleCard
                          key={article.fields.id}
                          article={article}
                          onClick={onClick} />),
                      )}
                      <p>{pageStrings['need-help']}
                        <a
                          target='blank'
                          rel='noopenner noreferrer'
                          href={pageStrings['customer-support-link']}>
                          {pageStrings['customer-support-text']}
                        </a>
                      </p>
                    </React.Fragment>
                  )}
                </div>
                <BottomButton
                  next={nextArticle}
                  prev={prevArticle}
                  label={pageStrings[nextArticle]}
                  onClick={onClick}
                  canGoBack={canGoBack} />
              </React.Fragment>
            ) : (
              <div className='actionButton'>
                <Button
                  type='primary'
                  size='large'
                  onClick={goToNext}>
                  {pageStrings['onboarding-next-button']}
                </Button>
              </div>
            )}
        </div>
      </div>
    </div>
  );
};

Unboxing.propTypes = {
  pageStrings: pageStringsPropType.isRequired,
  nextUrl: PropTypes.string.isRequired, // eslint-disable-line react/no-unused-prop-types
  title: PropTypes.string,
  subTitle: PropTypes.string,
  unboxingArticle: PropTypes.shape(articlePropTypes),
  features: PropTypes.shape({
    UNBOXING_UPDATE_ENABLED: PropTypes.bool,
  }),
  goTo: PropTypes.func.isRequired,
  params: PropTypes.shape({
    slug: PropTypes.string,
  }),
  articleList: PropTypes.arrayOf(PropTypes.shape(articlePropTypes)).isRequired,
};

Unboxing.defaultProps = {
  title: null,
  subTitle: null,
  textBlock: null,
  article: {},
  unboxingArticle: {},
  features: {},
  params: {},
};

export default Unboxing;



// WEBPACK FOOTER //
// ./app/components/setup/unboxing.jsx